import increaseColorPointByRatio from '../../../common/utils/increase-color-point-by-ratio';

const light = (params) => {
  const { infoColorPalette, backgroundColor } = params;
  const fallback = {
    rule: 'focusBorder.focus.light',
    params,
  };

  return increaseColorPointByRatio(
    {
      targetColor: infoColorPalette[50],
      backgroundColor,
      targetColorPalette: infoColorPalette,
      condition: (ratio) => ratio >= 1.2,
      fallback,
    },
    '50'
  );
};

export default light;
